export default function FeVersion() {
  const feVersion = process.env.BIG_FLIP_TAG_NAME;

  return `{ "version" : "${feVersion}" }`;
}
